import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  addCandidateEducation,
  deleteCandidateEducation,
  updateCandidateEducation,
} from "../../../redux/actions/admin/CandidateActions";
import Select from "react-select";
import moment from "moment";
import "moment/locale/fr";
import { CircularProgress } from "@material-ui/core";
import localStorageService from "../../../services/localStorageService";
import { degrees } from "../../shared/Helper";

let EducationResume = (props) => {
  const {
    educationList,
    addCandidateEducation,
    deleteCandidateEducation,
    updateCandidateEducation,
  } = props;
  const closeDeleteEducationModal = React.useRef();
  const [
    displayingCandidateEducationList,
    setDisplayCandidateEducationList,
  ] = React.useState([]);
  const [candidate, setCandidate] = React.useState(null);
  const [showForm, setShowForm] = React.useState(false);
  const [showUpdateForm, setShowUpdateForm] = React.useState({});
  const [isEducationAdding, setIsEducationAdding] = React.useState(false);
  const [isEducationDeleting, setIsEducationDeletting] = React.useState(false);
  const [isEducationUpdating, setIsEducationUpdating] = React.useState(false);
  const [published, setPublished] = React.useState(false);
  const [educationTodelete, setEducationTodelete] = React.useState(null);
  const [newEducation, setNewEducation] = React.useState({
    candidateId: "",
    title: "",
    degree: "",
    startYear: "",
    endYear: "",
    institute: "",
    description: "",
  });
  const [educationToUpdate, setEducationToUpdate] = React.useState({});

  useEffect(() => {
    if (educationList !== null) {
      setDisplayCandidateEducationList(educationList);
    }
  }, [educationList]);

  const generateYearOptions = () => {
    const currentYear = moment().year();
    const years = [];

    for (let i = currentYear; i >= currentYear - 50; i--) {
      years.push({ value: i, label: i });
    }

    return years;
  };

  const toggleForm = () => {
    setShowForm(!showForm);
  };
  const toggleUpdateForm = (education) => {
    setEducationToUpdate(education);
    setShowUpdateForm((prevState) => ({
      ...prevState,
      [education.id]: !prevState[education.id],
    }));
  };

  const handleCreateEducationSubmit = async () => {
    setIsEducationAdding(true);
    let education = newEducation;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    education.candidateId = candidate.id;
    try {
      const data = await addCandidateEducation(education);
      if (data.success === true) {
        setDisplayCandidateEducationList(data.candidate.educations);
        // setEducationToUpdate(data.candidate.educations);
        setCandidate(data.candidate);
        clearEducationForm();
      }
      setIsEducationAdding(false);
      setPublished(true);
      setShowForm(false);
    } catch (error) {
      setIsEducationAdding(false);
    }
  };

  const clearEducationForm = () => {
    setNewEducation({
      candidateId: "",
      title: "",
      degree: "",
      startYear: "",
      endYear: "",
      institute: "",
      description: "",
    });
  };

  const handleUpdateEducationSubmit = () => {
    setIsEducationUpdating(true);
    let education = educationToUpdate;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    education.candidateId = candidate.id;
    updateCandidateEducation(education).then((data) => {
      if (data.success) {
        setDisplayCandidateEducationList(data.candidate.educations);
        setCandidate(data.candidate);
      }
      setIsEducationUpdating(false);
      setPublished(true);
      toggleUpdateForm(education);
    });
  };

  const handleDeleteEducationSubmit = () => {
    setIsEducationDeletting(true);
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    deleteCandidateEducation(candidate?.id, educationTodelete.id).then(
      (resp) => {
        if (resp.success == true) {
          setDisplayCandidateEducationList(resp.candidate.educations);
          setEducationToUpdate(resp.candidate.educations);
          setCandidate(resp.candidate);
        }
        setEducationTodelete("");
        closeDeleteEducationModal.current.click();
        setIsEducationDeletting(false);
      }
    );
  };

  return (
    <React.Fragment>
      <div className="bg-light-3 p-4">
        <div className="row">
          <div className="col-md-7 col-sm-5 d-flex align-items-center">
            <div className="section-title mb-0 ">
              <h3 className="title mb-0">
                <span>Parcours scolaire</span>
              </h3>
            </div>
          </div>
          <div
            className="col-md-5 col-sm-7 mt-3 mt-sm-0 pr-3"
            style={{ textAlign: "right" }}
          >
            <button className="btn btn-primary" onClick={toggleForm}>
              Ajouter un parcours
            </button>
          </div>
        </div>
        {showForm == true && (
          <div className="row">
            <div className="col-xl-12">
              <div className="mt-4">
                <div className="bg-light-3">
                  <div _lpchecked="1">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <label>Titre </label>
                        <input
                          value={newEducation.title}
                          type="text"
                          className="form-control"
                          id="title"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewEducation((prevState) => {
                              return { ...prevState, title: val };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>Année du debut</label>
                        <Select
                          options={generateYearOptions()}
                          value={generateYearOptions().find(
                            (opt) => opt.value == newEducation.startYear
                          )}
                          onChange={(selectedOption) => {
                            const val = selectedOption.value;
                            setNewEducation((prevState) => ({
                              ...prevState,
                              startYear: val,
                            }));
                          }}
                          placeholder=""
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>Année de fin</label>
                        <Select
                          options={generateYearOptions()}
                          value={generateYearOptions().find(
                            (opt) => opt.value == newEducation.endYear
                          )}
                          onChange={(selectedOption) => {
                            const val = selectedOption.value;
                            setNewEducation((prevState) => ({
                              ...prevState,
                              endYear: val,
                            }));
                          }}
                          placeholder=""
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>Diplôme</label>
                        <Select
                          value={degrees.find(
                            (opt) => opt.value == newEducation.degree
                          )}
                          options={degrees}
                          id="degree"
                          onChange={(e) => {
                            let val = e.value;
                            setNewEducation((prevState) => {
                              return { ...prevState, degree: val };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>Institut</label>
                        <input
                          value={newEducation.institute}
                          type="text"
                          className="form-control"
                          id="institute"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewEducation((prevState) => {
                              return { ...prevState, institute: val };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-12">
                        <label>Description</label>
                        <textarea
                          value={newEducation.description}
                          type="text"
                          className="form-control"
                          id="description"
                          placeholder=""
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewEducation((prevState) => {
                              return { ...prevState, description: val };
                            });
                          }}
                        ></textarea>
                      </div>
                      <div className="col-12 mt-4">
                        <button
                          className="btn btn-primary"
                          onClick={handleCreateEducationSubmit}
                          disabled={isEducationAdding}
                          style={{ textAlign: "right", float: "right" }}
                        >
                          Ajouter &nbsp;{" "}
                          {isEducationAdding ? (
                            <CircularProgress size={15} />
                          ) : (
                            <span></span>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-xl-12">
            {displayingCandidateEducationList?.length !== 0 && (
              <div className="timeline-box bg-white p-3 mt-4">
                <div className="jobster-candidate-timeline">
                  <div className="jobster-timeline-icon">
                    <i className="fas fa-graduation-cap"></i>
                  </div>

                  {displayingCandidateEducationList?.map((education, index) => (
                    <div className="jobster-timeline-item" key={index}>
                      <div className="jobster-timeline-cricle">
                        <i className="far fa-circle"></i>
                      </div>
                      <div className="jobster-timeline-info">
                        <div className="dashboard-timeline-info">
                          <div className="row">
                            <div className="col-12">
                              <div className="row">
                                <div className="col-12">
                                  <div className="row">
                                    <div className="col-10">
                                      <span className="jobster-timeline-time">
                                        {education.startYear} -{" "}
                                        {education.endYear}
                                      </span>
                                    </div>
                                    <div className="col-2">
                                      <div className="dashboard-timeline-edit">
                                        <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                          <li className="pr-2">
                                            <a
                                              href="javascript:void(0)"
                                              onClick={() =>
                                                toggleUpdateForm(education)
                                              }
                                            >
                                              <i className="fas fa-pencil-alt"></i>
                                            </a>
                                          </li>
                                          <li>
                                            <a
                                              href="#"
                                              className="text-danger"
                                              data-toggle="modal"
                                              title=""
                                              data-target="#deleteEducation"
                                              data-original-title="Delete"
                                            >
                                              <i
                                                className="far fa-trash-alt text-danger"
                                                onClick={() =>
                                                  setEducationTodelete(
                                                    education
                                                  )
                                                }
                                              ></i>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>

                                  <h6 className="mb-2">{education.title}</h6>
                                  <span>- {education.institute}</span>
                                  <p className="mt-2">
                                    {education.description}
                                  </p>
                                </div>
                                {showUpdateForm[education.id] && (
                                  <div className="col-12">
                                    <div className="mt-4">
                                      <div className="bg-light-3 p-4">
                                        <div _lpchecked="1">
                                          <div className="form-row">
                                            <div className="form-group col-md-12">
                                              <label>Titre </label>
                                              <input
                                                value={educationToUpdate.title}
                                                type="text"
                                                className="form-control"
                                                id="title"
                                                onChange={(e) => {
                                                  let val = e.target?.value;
                                                  setEducationToUpdate(
                                                    (prevState) => {
                                                      return {
                                                        ...prevState,
                                                        title: val,
                                                      };
                                                    }
                                                  );
                                                }}
                                              />
                                            </div>
                                            <div className="form-group col-md-6">
                                              <label>Année de debut</label>
                                              <Select
                                                options={generateYearOptions()}
                                                value={generateYearOptions().find(
                                                  (opt) =>
                                                    opt.value ===
                                                    educationToUpdate.startYear
                                                )}
                                                onChange={(selectedOption) => {
                                                  const val =
                                                    selectedOption.value;
                                                  setEducationToUpdate(
                                                    (prevState) => ({
                                                      ...prevState,
                                                      startYear: val,
                                                    })
                                                  );
                                                }}
                                                placeholder=""
                                              />
                                            </div>

                                            <div className="form-group col-md-6">
                                              <label>Année de fin</label>
                                              <Select
                                                options={generateYearOptions()}
                                                value={generateYearOptions().find(
                                                  (opt) =>
                                                    opt.value ===
                                                    educationToUpdate.endYear
                                                )}
                                                onChange={(selectedOption) => {
                                                  const val =
                                                    selectedOption.value;
                                                  setEducationToUpdate(
                                                    (prevState) => ({
                                                      ...prevState,
                                                      endYear: val,
                                                    })
                                                  );
                                                }}
                                                placeholder=""
                                              />
                                            </div>
                                            <div className="form-group col-md-6">
                                              <label>Diplôme</label>
                                              <Select
                                                value={degrees.find(
                                                  (opt) =>
                                                    opt.value ===
                                                    educationToUpdate.degree
                                                )}
                                                options={degrees}
                                                id="degree"
                                                onChange={(e) => {
                                                  let val = e.value;
                                                  setEducationToUpdate(
                                                    (prevState) => {
                                                      return {
                                                        ...prevState,
                                                        degree: val,
                                                      };
                                                    }
                                                  );
                                                }}
                                              />
                                            </div>
                                            <div className="form-group col-md-6">
                                              <label>Institut</label>
                                              <input
                                                value={
                                                  educationToUpdate.institute
                                                }
                                                type="text"
                                                className="form-control"
                                                id="institute"
                                                onChange={(e) => {
                                                  let val = e.target?.value;
                                                  setEducationToUpdate(
                                                    (prevState) => {
                                                      return {
                                                        ...prevState,
                                                        institute: val,
                                                      };
                                                    }
                                                  );
                                                }}
                                              />
                                            </div>
                                            <div className="form-group col-md-12">
                                              <label>Description</label>
                                              <textarea
                                                value={
                                                  educationToUpdate.description
                                                }
                                                type="text"
                                                className="form-control"
                                                id="description"
                                                placeholder=""
                                                onChange={(e) => {
                                                  let val = e.target?.value;
                                                  setEducationToUpdate(
                                                    (prevState) => {
                                                      return {
                                                        ...prevState,
                                                        description: val,
                                                      };
                                                    }
                                                  );
                                                }}
                                              ></textarea>
                                            </div>
                                            <div className="col-12 mt-4">
                                              <button
                                                className="btn btn-primary"
                                                onClick={
                                                  handleUpdateEducationSubmit
                                                }
                                                disabled={isEducationUpdating}
                                                style={{
                                                  textAlign: "right",
                                                  float: "right",
                                                }}
                                              >
                                                Mettre à jour &nbsp;{" "}
                                                {isEducationUpdating ? (
                                                  <CircularProgress size={15} />
                                                ) : (
                                                  <span></span>
                                                )}
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Start Delete  modale */}
        <div
          className="modal fade"
          id="deleteEducation"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header p-4">
                <h4 className="mb-0 text-center">
                  Suppression d'un parcours scolaire
                </h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <form className="mt-2">
                <div className="modal-body">
                  <div>
                    <div className="form-row">
                      <p>
                        Voulez vous supprimer ce parcours:{" "}
                        {educationTodelete?.title}?
                      </p>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    data-dismiss="modal"
                    className="btn btn-primary"
                    ref={closeDeleteEducationModal}
                  >
                    NON
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleDeleteEducationSubmit}
                    disabled={isEducationDeleting}
                  >
                    OUI &nbsp;{" "}
                    {isEducationDeleting ? (
                      <CircularProgress size={15} />
                    ) : (
                      <span></span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* End Delete  modale */}
      </div>
    </React.Fragment>
  );
};

EducationResume.propTypes = {
  addCandidateEducation: PropTypes.func.isRequired,
  deleteCandidateEducation: PropTypes.func.isRequired,
  updateCandidateEducation: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  addCandidateEducation: PropTypes.func.isRequired,
  deleteCandidateEducation: PropTypes.func.isRequired,
  updateCandidateEducation: PropTypes.func.isRequired,
});

export default connect(mapStateToProps, {
  addCandidateEducation,
  deleteCandidateEducation,
  updateCandidateEducation,
})(EducationResume);
